export const RESET = 'mpa/redux-rest-response/RESET';
